export default function getComponentDisplayName(
    WrappedComponent: {
        displayName?: string;
        name?: string;
    },
    fallback = 'anonymous'
): string {
    return WrappedComponent.displayName ?? WrappedComponent.name ?? fallback;
}
